import React from 'react'
import { PiDevicesThin } from 'react-icons/pi'

const LinkDevice = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 557px)" }}><PiDevicesThin className='text-center text-white' style={{ fontSize: 150 }} /></div>
            <div className="text-center"><span className='fw-bold fs-30  text-white'>Activiate Galax OTT Player on Your Android Smart Tv </span></div>
            <div className="linkMessage"><span>Enter the activation code displayed on your TV screen</span></div>
            <div className="text-center">
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
                <input type="text" pattern="[a-zA-Z0-9]+" maxLength="1" className="tv-code-input  " />
            </div>
            <button type="button" className="tv-login-btn">Activiate Device</button>
        </>
    )
}

export default LinkDevice